import React, {useState} from "react";
import {DialogContent, DialogTitle, Divider} from "@mui/material";
import * as Yup from "yup";
import {makeRequired, makeValidate} from "mui-rff";
import {Col} from "reactstrap";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import Dialog from "../../../../../components/base/dialog";
import Form from "../../../../../components/base/form";
import {OutlinedInputForm} from "../../../../../components/base/input/outlined_input";
import Button from "../../../../../components/base/button/button";

const schema = Yup.object().shape({
    title: Yup.string().nullable().trim().required(ValidateMessages.required),
    industry: Yup.object().nullable(),
});


const validate = makeValidate(schema);
const required = makeRequired(schema);


const CreateNewUserHomepageEntity = ({open, close, label, create, showIndustry}) => {
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Submits a new entity for the product application.
     *
     * @param {any} values form values
     * @param {formApi} form
     * @return {Promise<void>}
     */
    const submit = async (values, form) => {
        const resultFlag = await create(values);
        if (!isMounted()) return;
        setSubmitting(false);
        if (resultFlag) {
            close();
            form.change('title', undefined);
            form.resetFieldState('title');
        }
    }

    return (
        <>
            <Dialog
                open={open}
                setOpen={() => close()}
                maxWidth={'sm'}
                loading={submitting}
                className={'bound-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        Add a new {label}
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent className={'px-2'}>
                    <Col xs={12} className={'mb-5 mt-4'}>
                        <p className={'text-sm font-weight-regular mt-2 mb-2'}>
                            please enter the title of the {label} for your client-homepage.
                        </p>
                    </Col>
                    <Col xs={12} className={'mb-4'}>
                        <Form
                            className='d-flex flex-wrap w-100 align-items-start'
                            onSubmit={submit}
                            validate={validate}
                            initialValues={{
                                // industry: cachedIndustry
                            }}
                            render={({values, form}) => {
                                return (
                                    <>
                                        <Col xs={'auto'} className={'p-0 flex-grow-1'}>
                                            <OutlinedInputForm
                                                fullWidth
                                                name={'title'}
                                                placeholder={'title'}
                                                label={"Title"}
                                                className={'mr-2'}
                                                required={required.title}
                                                value={values.title ?? ''}
                                                onChange={(e) => form.change(e.target.name, e.target.value)}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'d-flex flex-column mt-1'}>
                                            <Button
                                                className='py-2-5 px-5 m-auto'
                                                type={'submit'}
                                                variant={'contained'}
                                                color={'primary'}
                                                disabled={submitting}
                                            >
                                                {
                                                    submitting
                                                        ? "Creating..."
                                                        : "Create"
                                                }
                                            </Button>
                                        </Col>
                                    </>
                                )
                            }}
                        />
                    </Col>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CreateNewUserHomepageEntity;
